import PropTypes from 'prop-types'
import { SelectHTMLAttributes } from 'react'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  id?: string
  label?: string
  tight?: boolean
}

export default function Select({
  id,
  onChange,
  children,
  value,
  label,
  disabled,
  tight,
  ...props
}: SelectProps) {
  return (
    <>
      {label && (
        <label
          className={`tw-text-system-grey-400  tw-custom-uppercase ${
            tight ? 'tw-text-xs tw-mb-0' : 'tw-text-sm tw-mb-1'
          }`}
          htmlFor={id}>
          {label}
        </label>
      )}
      <div className={`tw-relative ${!tight ? 'tw-w-full' : ''}`}>
        <select
          id={id}
          disabled={disabled}
          className={`
          tw-block
          tw-appearance-none 
          tw-bg-white 
          tw-border
          tw-border-system-grey-300 
          tw-rounded
          tw-shadow
          tw-leading-tight
          ${
            disabled
              ? 'hover:tw-cursor-not-allowed tw-text-system-grey-400'
              : 'hover:tw-border-system-grey-400'
          }
          ${
            tight
              ? 'tw-text-sm tw-custom-uppercase tw-p-1 tw-pr-4'
              : 'tw-w-full tw-px-2 tw-py-2 tw-pr-8'
          }
          focus:tw-outline-none
          focus:tw-ring`}
          onChange={onChange}
          value={value}
          {...props}>
          {children}
        </select>
        <div
          className={`tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-system-grey-300 ${
            tight ? 'tw-text-sm' : 'tw-text-xl'
          }`}>
          <i className="tw-fill-current tw-h-4 tw-w-4 fas fa-angle-down"></i>
        </div>
      </div>
    </>
  )
}

Select.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
